import { useState } from "react";
import { searchCustomer } from "src/apis/customerApi";
import useUiuxStore from "src/store/useUiuxStore";
import { defaultWMS1030_R01Filter, useWMS1030_R01Store } from "src/containers/mes/WMS/WMS1030_R01/Store_WMS1030_R01";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

interface Props {
  onEnterKeyDown: () => void;
}

export const SearchSection_WMS1030_R01 = (props: Props) => {
	const { onEnterKeyDown } = props;
	const { WMS1030_R01Filter, setWMS1030_R01Filter } = useWMS1030_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const custInfoHandleFoucsId = 'infoCustInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			}
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: WMS1030_R01Filter,
		setEditData: setWMS1030_R01Filter,
		defaultData: defaultWMS1030_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS1030_R01_search'
	});

	return (
		<SearchSectionForm>
			<SearchDateRangeForm
				label="출고 요청 기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={WMS1030_R01Filter.dateRange}
				setDateRange={(dateRange) => setWMS1030_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
				wrapperOption={{
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]",
				}}
			/>

			<SearchInputForm
				label="지시번호"
				value={WMS1030_R01Filter.wmsOrderNo}
				onChange={(e) => setWMS1030_R01Filter({ wmsOrderNo: e.target.value })}
				onKeyDown={(e) => {
					if (e.key === 'Enter') onEnterKeyDown();
				}}
				initValue={() => setWMS1030_R01Filter({ wmsOrderNo: '' })}
				wrapperOption={{
					wrapperStyle: "w-[220px] min-w-[220px] mr-[10px]",
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[50px] min-w-[50px]",
					inputStyle: "w-[150px] min-w-[150px] border border-gray-300 px-[6px] h-[24px] rounded-[6px]",
				}}
			/>

			<SearchCodeModalForm
				label="거래처"
				value={WMS1030_R01Filter.customCd}
				valueLabel={WMS1030_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_WMS1030_R01;